import PropTypes from 'prop-types';
import { useState } from 'react';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

// project imports
import { useAuth } from 'contexts/AuthContext';

// assets
import MailOutlined from '@ant-design/icons/MailOutlined';
import PhoneOutlined from '@ant-design/icons/PhoneOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ handleLogout }) {
  const { user } = useAuth();

  const formatRole = (role) => {
    const roles = {
      'ADMIN': 'Administrador',
      'SUPERVISOR': 'Supervisor',
      'PROMOTER': 'Promotor'
    };
    return roles[role] || role;
  };

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      {/* Informações do Usuário */}
      <Box sx={{ p: 2, pb: 0 }}>
        <Typography variant="h6" color="text.primary" gutterBottom>
          Informações do Perfil
        </Typography>
      </Box>

      <ListItemButton>
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText 
          primary="Nome" 
          secondary={user?.name || 'Não informado'}
          secondaryTypographyProps={{ color: 'text.primary' }}
        />
      </ListItemButton>

      <ListItemButton>
        <ListItemIcon>
          <MailOutlined />
        </ListItemIcon>
        <ListItemText 
          primary="Email" 
          secondary={user?.email || 'Não informado'}
          secondaryTypographyProps={{ color: 'text.primary' }}
        />
      </ListItemButton>

      <ListItemButton>
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText 
          primary="Função" 
          secondary={formatRole(user?.role)}
          secondaryTypographyProps={{ color: 'text.primary' }}
        />
      </ListItemButton>

      {user?.phone && (
        <ListItemButton>
          <ListItemIcon>
            <PhoneOutlined />
          </ListItemIcon>
          <ListItemText 
            primary="Telefone" 
            secondary={user.phone}
            secondaryTypographyProps={{ color: 'text.primary' }}
          />
        </ListItemButton>
      )}

      <Divider sx={{ my: 1 }} />

      <ListItemButton onClick={handleLogout} sx={{ color: 'error.main' }}>
        <ListItemIcon sx={{ color: 'error.main' }}>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary="Sair" />
      </ListItemButton>
    </List>
  );
}

ProfileTab.propTypes = { handleLogout: PropTypes.func };
